/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Invoice
 */
export interface Invoice {
    /**
     * 
     * @type {number}
     * @memberof Invoice
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    currencyIso: string;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    amount: string;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    invoiceReference: string;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    invoiceInfo: string;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    invoiceDirection: string;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    invoiceDateTime?: string;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    invoiceStatus: string;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    dueDateTime?: string;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    remainingBalance: string;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    created: string;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    invoiceType: string;
    /**
     * 
     * @type {number}
     * @memberof Invoice
     */
    reminderLevel: number;
    /**
     * 
     * @type {boolean}
     * @memberof Invoice
     */
    isCancellableByEConnector: boolean;
    /**
     * 
     * @type {number}
     * @memberof Invoice
     */
    financialGroupId?: number;
}

/**
 * Check if a given object implements the Invoice interface.
 */
export function instanceOfInvoice(value: object): value is Invoice {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('currencyIso' in value) || value['currencyIso'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('invoiceReference' in value) || value['invoiceReference'] === undefined) return false;
    if (!('invoiceInfo' in value) || value['invoiceInfo'] === undefined) return false;
    if (!('invoiceDirection' in value) || value['invoiceDirection'] === undefined) return false;
    if (!('invoiceStatus' in value) || value['invoiceStatus'] === undefined) return false;
    if (!('remainingBalance' in value) || value['remainingBalance'] === undefined) return false;
    if (!('created' in value) || value['created'] === undefined) return false;
    if (!('invoiceType' in value) || value['invoiceType'] === undefined) return false;
    if (!('reminderLevel' in value) || value['reminderLevel'] === undefined) return false;
    if (!('isCancellableByEConnector' in value) || value['isCancellableByEConnector'] === undefined) return false;
    return true;
}

export function InvoiceFromJSON(json: any): Invoice {
    return InvoiceFromJSONTyped(json, false);
}

export function InvoiceFromJSONTyped(json: any, ignoreDiscriminator: boolean): Invoice {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'currencyIso': json['currencyIso'],
        'amount': json['amount'],
        'invoiceReference': json['invoiceReference'],
        'invoiceInfo': json['invoiceInfo'],
        'invoiceDirection': json['invoiceDirection'],
        'invoiceDateTime': json['invoiceDateTime'] == null ? undefined : json['invoiceDateTime'],
        'invoiceStatus': json['invoiceStatus'],
        'dueDateTime': json['dueDateTime'] == null ? undefined : json['dueDateTime'],
        'remainingBalance': json['remainingBalance'],
        'created': json['created'],
        'invoiceType': json['invoiceType'],
        'reminderLevel': json['reminderLevel'],
        'isCancellableByEConnector': json['isCancellableByEConnector'],
        'financialGroupId': json['financialGroupId'] == null ? undefined : json['financialGroupId'],
    };
}

export function InvoiceToJSON(json: any): Invoice {
    return InvoiceToJSONTyped(json, false);
}

export function InvoiceToJSONTyped(value?: Invoice | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'currencyIso': value['currencyIso'],
        'amount': value['amount'],
        'invoiceReference': value['invoiceReference'],
        'invoiceInfo': value['invoiceInfo'],
        'invoiceDirection': value['invoiceDirection'],
        'invoiceDateTime': value['invoiceDateTime'],
        'invoiceStatus': value['invoiceStatus'],
        'dueDateTime': value['dueDateTime'],
        'remainingBalance': value['remainingBalance'],
        'created': value['created'],
        'invoiceType': value['invoiceType'],
        'reminderLevel': value['reminderLevel'],
        'isCancellableByEConnector': value['isCancellableByEConnector'],
        'financialGroupId': value['financialGroupId'],
    };
}

